// extracted by mini-css-extract-plugin
export default {"terminal-input":"TerminalInput__terminal-input___2BOHj","input-textbox":"TerminalInput__input-textbox___v-9P7"};